import React from "react";
import OrderList from "../../components/OrderList/OrderList"

const Orders = () => {
  return (
    <div className="container mx-auto">
        <OrderList></OrderList>
    </div>
  );
};

export default Orders;